export const BACKGROUND_URLS = [
    'https://images.unsplash.com/photo-1542480118439-cbba7870f6f7?q=80&w=1976&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    'https://images.unsplash.com/photo-1730292422804-5bbb2bd2d3f0?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
];

export function getRandomBackground() {
    const randomIndex = Math.floor(Math.random() * BACKGROUND_URLS.length);
    return BACKGROUND_URLS[randomIndex];
} 